export default function Plus (props) {

    return (
        <svg className={props.className} style={props.style} fill={'transparent'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8">
            <path d="M 4 0 L 4 8 M 0 4 L 8 4"/>
        </svg>
    )

}